import { getAppVersion } from '$tablet-app/src/app/utils/version';
import { spacing } from '@akin-home/theme';
import { isWebBuild } from '@akin-home/utils/native';
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import styled from 'styled-components/native';
import { BackHeader } from '../components/BackHeader';
import { LoginScreenViewProps } from './types';

export const PortraitLoginScreenView = (props: LoginScreenViewProps) => {
  const version = getAppVersion();

  return (
    <Container>
      <LogoImage
        resizeMode="contain"
        source={require('../assets/heypixi-logo.png')}
      />

      <ScrollView contentContainerStyle={styles.scrollViewContentContainer}>
        <Panel>
          {props.onPressBack ? (
            <BackHeader onPress={props.onPressBack} />
          ) : null}

          {props.body}
        </Panel>

        {!isWebBuild() ? (
          <VersionText>App Version: {version}</VersionText>
        ) : null}
      </ScrollView>
    </Container>
  );
};

const Container = styled(View)`
  flex: 1;
  background-color: #f6f7f9;
  padding: 20px;
  flex-direction: column;
  position: relative;
`;

const Panel = styled(View)`
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  justify-content: center;
  align-items: center;
  gap: ${spacing[2]}px;
`;

const LogoImage = styled.Image`
  width: 160px;
  height: 60px;
  align-self: center;
  margin: ${spacing[6]}px;
`;

const VersionText = styled.Text`
  font-family: Inter-Regular;
  font-size: 13px;
  margin-top: auto;
  align-self: flex-end;
`;

const styles = StyleSheet.create({
  scrollViewContentContainer: {
    flexGrow: 1,
    padding: spacing[2],
    gap: 16,
  },
});
